export default __webpack_public_path__ + "d6a5aed419e774ba740ca964d5966c83.png";